export const DEFAULT_ROWS = 15;
